<template>
  <PageWrapper>
    <NavbarMain />
    <BaseAlertMessage />
    <OpportunityNewContainer  />
    <Footer />
  </PageWrapper>
</template>

<script>
import PageWrapper from '@/components/_shared/PageWrapper.vue'
import NavbarMain from '@/components/_shared/navbar-main/NavbarMain.vue'
import OpportunityNewContainer from '@/components/opportunity-new/OpportunityNewContainer.vue'
import Footer from '@/components/_shared/Footer.vue'

export default {
  name: 'NewOpportunity',
  components: {
    PageWrapper,
    NavbarMain,
    OpportunityNewContainer,
    Footer
  }
}
</script>
